import React from 'react';
import Before1July2025Content from './ja-before-20250701-terms';
import After1July2025Content from './ja-after-20250701-terms';

import * as styles from './ja.module.scss';

const JA_NEW_CONTENT_TIME_20250701 = '2025-07-01T00:01:00+09:00' // JST
class JaTermsConditions extends React.Component {
  isNewContentTime() {
    const cutoffDate = new Date(JA_NEW_CONTENT_TIME_20250701);
    return new Date() > cutoffDate;
  }

  render() {
    return (
      <div className={styles.JaTermsConditions}>
        {this.isNewContentTime() ? <After1July2025Content /> : <Before1July2025Content />}
      </div>
    );
  }
}

export default JaTermsConditions;
